import { commonShortFieldLabels, commonShortNouns } from "./common-short-fields";

export const examAdminExecutionAttackDefense = {
  pageTitle: "攻防環境パネル",
  pageSubtitle: "攻防問題の環境作成記録と Flag 提出記録を確認します。",
  sourceExam: "試験",
  sourceDebug: "デバッグ",
  statsTotal: "総数：{count}",
  statsRunning: "実行中：{count}",
  statsDestroyed: "破棄済み：{count}",
  statsDynamic: "動的 Flag：{count}",
  statsStatic: "静的 Flag：{count}",
  columns: {
    instanceId: "インスタンス ID",
    source: "ソース",
    examInfo: "試験情報",
    question: "問題",
    questionVersionCode: "問題バージョンコード",
    candidate: "受験者",
    status: commonShortNouns.status,
    containerId: "コンテナ ID",
    webEndpoint: "Web エンドポイント",
    imageName: "イメージ",
    flagMode: "Flag モード",
    flagEnvKey: "Flag 環境変数キー",
    flagValue: "Flag",
    flagSha256: "Flag ハッシュ",
    creator: "作成者",
    lifetime: "稼働時間",
    startedAt: "開始日時",
    createdAt: commonShortFieldLabels.createdAt,
    expiresAt: "有効期限",
    destroyedAt: "破棄日時",
    actions: "操作",
  },
  actions: {
    viewFlagSubmissions: "Flag 提出履歴",
    viewAttempt: "受験詳細",
    recycleInstance: "回収",
  },
  messages: {
    recycleSubmissionSubmitted: "環境インスタンスの破棄リクエストを送信しました",
  },
  flagSubmissionsTitle: "Flag 提出記録（インスタンス #{id}）",
  flagSubmissionsEmpty: "Flag 提出記録はありません",
  flagSubmissionColumns: {
    id: "ID",
    flagValue: "Flag",
    result: "判定",
    submittedAt: "提出時間",
  },
  resultCorrect: "正解",
  resultIncorrect: "不正解",
  resultUnknown: "不明",
  statusRunning: "実行中",
  statusReady: "準備完了",
  statusEvaluated: "評価済み",
  statusProvisioning: "作成中",
  statusPending: "待機中",
  statusDestroyed: "破棄済み",
  statusDebug: "デバッグ中",
  flagModeDynamic: "動的",
  flagModeStatic: "静的",
  examInfoEmpty: "デバッグインスタンス",
} as const;
